/** Icons are imported separatly to reduce build time */
import InboxArrowDownIcon from "@heroicons/react/24/outline/InboxArrowDownIcon";

const iconClasses = `h-6 w-6`;

const routes = [
  {
    path: "/", // url
    icon: <InboxArrowDownIcon className={iconClasses} />, // icon component
    name: "Home", // name that appear in Sidebar
  },
  {
    path: "/messages", // url
    icon: <InboxArrowDownIcon className={iconClasses} />, // icon component
    name: "Messages", // name that appear in Sidebar
  },
  {
    path: "/schedules", // url
    icon: <InboxArrowDownIcon className={iconClasses} />, // icon component
    name: "Schedules", // name that appear in Sidebar
  },
  {
    path: "/services", // url
    icon: <InboxArrowDownIcon className={iconClasses} />, // icon component
    name: "Services", // name that appear in Sidebar
  },
  {
    path: "/weekly-bulletins", // url
    icon: <InboxArrowDownIcon className={iconClasses} />, // icon component
    name: "Weekly Bulletins", // name that appear in Sidebar
  },
];

export default routes;
